import React, { useContext } from 'react';
import { usePriceAlertModal } from './PriceAlertModalContext';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useGuestGuideTelemetry } from './GuestGuideTelemetry';
import { AnalyticsContext } from '@shared/core';
import { PriceAlertModal } from '@shared/components/PriceAlertModal/PriceAlertModal.lazy';
import { differenceInCalendarDays } from 'date-fns';
import { useTravelAlertSubscriptionStatus } from '@shared/components/PriceAlertModal/useTravelAlertSubscriptionStatus';
import { useHotelRoutePaths } from '@apps/guest/routes/HotelBooking/HotelBooking.routes';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useHistory } from '@react-router';

const CUSTOM_OFFSET = { x: 16, y: 38 } as const;

export const PriceAlertModalWrapper: React.FC = () => {
  const { isOpen, onClose } = usePriceAlertModal();
  const { eventInfo, eventHandle } = useEventInfo();
  const telemetry = useGuestGuideTelemetry();
  const { anonymousId } = useContext(AnalyticsContext);
  const hotelRoutePaths = useHotelRoutePaths();
  const history = useHistory();

  const eventId = eventInfo?.eventId;

  const { existingSubscription } = useTravelAlertSubscriptionStatus({
    eventId,
    anonymousId,
    skip: !isOpen,
  });

  const handleNavigateToAccommodations = useEventCallback(() => {
    if (!eventHandle) return;
    onClose();
    const url = hotelRoutePaths.accommodationsPage.buildRelativeUrl(eventHandle);
    history.push(url);
  });

  if (!isOpen || !eventId) {
    return null;
  }

  const daysUntilEvent = eventInfo.finalizedDate?.milliseconds !== undefined ? Math.max(0, differenceInCalendarDays(eventInfo.finalizedDate.milliseconds, Date.now())) : undefined;

  return (
    <PriceAlertModal
      isOpen={isOpen}
      onClose={onClose}
      eventId={eventId}
      source="GUEST_GUIDE"
      telemetry={telemetry}
      daysUntilEvent={daysUntilEvent}
      existingSubscription={existingSubscription}
      customOffset={CUSTOM_OFFSET}
      onNavigateToAccommodations={handleNavigateToAccommodations}
    />
  );
};
